

















import { defineComponent, useRoute } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

import { usePdpStore } from '~/store/pdp'
import { smoothScroll } from '~/common/utils/smoothScroll'
import usePDPAnalytics from '@/composables/analytics/usePDPAnalytics'

export default defineComponent({
  setup() {
    const { citationsCount } = storeToRefs(usePdpStore())
    const { trackCitationClick } = usePDPAnalytics()
    const route = useRoute()
    const url = route.value.path.toString()

    return {
      citationsCount,
      smoothScroll,
      trackCitationClick,
      url,
    }
  },
})
